import { Box, Flex, Text, IconButton, Image } from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import DefaultImage from "@root/assets/images/ChatSourceDefaultImage.svg";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useTranslation } from "react-i18next";
import LinkIcon from "@root/assets/icons/linkicon";
import { NewTabIcon } from "@root/assets/icons/NewTabIcon";

function handlePreviewClick(source: any) {
  if (typeof source === "object") {
    window.open(source?.signedUrl, "_blank");
  } else {
    window.open(source, "_blank");
  }
}

const ChatSources = () => {
  const { sourcesData, setSourcesData } = useMainChatContext();
  const { t } = useTranslation("common");

  return (
    <Flex
      py="15px"
      px="15px"
      flexDir="column"
      height="100%"
      position="relative"
    >
      {/* Header */}
      <Flex justifyContent="space-between" alignItems="center" mb="10px">
        <Text fontSize="20px" fontWeight={600} color="#005EB8">
          {t("translate.allSources")}
        </Text>
        <IconButton
          aria-label="Close"
          icon={<CloseIcon />}
          onClick={() => setSourcesData(null)}
          margin={0}
          boxSize={4}
          bg="transparent"
          color="black"
        />
      </Flex>

      {/* Body */}
      <Box flex={1} overflowY="auto">
        <Flex flexDir="column" gap="12px" mt="20px">
          {sourcesData?.map((source: any, index: number) => (
            <Flex
              key={index}
              border="1px solid #A7A9AB80"
              borderRadius="8px"
              px="14px"
              py="12px"
              gap="12px"
              alignItems="flex-start"
              cursor="pointer"
              _hover={{ bgColor: "#F0F2F7" }}
              onClick={() => handlePreviewClick(source)}
            >
              {/* Content */}
              <Box flex="1">
                {/* First line: icon + title + new tab */}
                <Flex
                  alignItems="center"
                  justifyContent="space-between"
                  mb="4px"
                >
                  <Flex alignItems="center" gap="6px">
                    <LinkIcon />
                    <Text
                      noOfLines={1}
                      fontWeight="600"
                      color="#231F20"
                      fontSize="14px"
                    >
                      {source?.folder_name || source?.filename || "Untitled"}
                    </Text>
                  </Flex>
                  <NewTabIcon />
                </Flex>

                {/* Second line: description */}
                <Text
                  noOfLines={2}
                  fontSize="13px"
                  color="#6D6D70"
                  lineHeight="1.4"
                >
                  {source?.filename ??
                    source?.description ??
                    "No description available"}
                </Text>
              </Box>
            </Flex>
          ))}
        </Flex>
      </Box>
    </Flex>
  );
};

export default ChatSources;
